<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="display-1">{{ reportTitle(true) }}</div>
      </div>
      <div class="col-12 col-md-8 align-right text-md-right">
        <div v-if="hasFilterProducts()" class="d-inline-block">Products:
          <filter-products :fieldData="chartProductFilters" :widgetType="'select'" :widgetStyle="'colorful'" class="d-inline-block mb-1"></filter-products>
        </div>

        <div class="d-inline-block">Date Control:
          <filter-daterange :fieldData="chartDateFiltersPrimary" class="d-inline-block mb-1"></filter-daterange>
          <filter-daterange :fieldData="chartDateFiltersSecondary" class="d-inline-block"></filter-daterange>
        </div>
      </div>
    </div>
    <hr>
    <summary-blocks :tableData="dataSummary"></summary-blocks>

    <div class="row mx-0 py-2 table-heading rounded-top">
      <div class="col-12 col-md-5 my-auto">
        <div>{{ reportTitle() }}</div>
      </div>
      <div class="col-12 col-md-7 align-md-right text-md-right my-auto">
        <b-form-group class="search-box-admin mb-0 mt-sm-2 mt-md-0 d-inline">
          <b-input-group>
            <b-input-group-text slot="prepend"><i class="fas fa-search"></i></b-input-group-text>
            <b-form-input v-model="filter" placeholder="Search Table" class="search-text-box-admin"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-button size="sm" variant="outline-light"
        v-if="hasSecondaryDimension"
        @click="resetDimensions()">Clear Dimension</b-button>
        <div class="d-inline-block ml-3">Filter {{ reportTitle() }}:</div>
        <a href="javascript:void();" id="dimension-filters" @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#dimension-filters-list"
        :class="{ 'active': is_showing('dimension-filters-list') }" class="nav-item-collapse d-inline-block">
          <i class="fas fa-sliders-h ml-2 secondary-icon"></i>
        </a>
      </div>
    </div>
    <div class="row mx-0 py-3 border-bottom" id="dimension-filters-list" :class="{ 'collapse': true, 'show': is_showing('dimension-filters-list') }" data-target="#dimension-filters">
      <div class="col-12">
        <div v-if="!!(persistentDimension)" class="row">
          <div class="col-12">
            <div>Secondary Dimension:</div>
            <filter-dimension :fieldData="chartDimensionFilters"></filter-dimension>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <filter-filters v-on:resetFilters="resetFilters" :chartFiltersFilters="chartFiltersFilters" :chartDimensionFilters="chartDimensionFilters"></filter-filters>
          </div>
        </div>
      </div>
    </div>
      <div class="row">
      <div class="col-md-12">
        <div v-if="true" class="animated fadeIn">
          <div class="row">
            <div class="col-lg-12">
              <div class="card rounded-bottom">
                <div id="report" class="card-body">
                  <datatable-block
                  :dataFilters="dataFilters"
                  :filter='filter'
                  :persistentDimension="persistentDimension"
                  :tableData="reportDataPrimary"
                  :tableDataSecondary="reportDataSecondary"
                  :chartFiltersFilters="chartFiltersFilters"
                  :dimensionProperty="this.dimensionProperty"
                  :isLoading="isLoading"
                  v-on:setPersistentDimension="setPersistentDimension"></datatable-block>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
/* eslint-disable */
import FilterDimension from '@/components/interactive/widgets/FilterDimension';
import FilterFilters from '@/components/interactive/widgets/FilterFilters';
import Report from '../../services/Report';
import ReportRequest from '../../services/ReportRequest';
import DateRangeFilter from '../../services/DateRangeFilter';
import ProductFilter from '../../services/ProductFilter';
import User from '../../services/User';
import LineChart from '../../services/LineChart';
import DatatableBlock from '../presentational/DatatableBlock';
import SummaryBlocks from '../presentational/SummaryBlocks';
import FilterDaterange from '../interactive/widgets/FilterDaterange';
import FilterProducts from '../interactive/widgets/FilterProducts';
import InputRadioalt from '../interactive/InputRadioalt';
import SortByfield from '../interactive/widgets/SortByfield';
import filters from '../../../config/admin/filters';
import QRP from '../../../config/QRP.env';

export default {
  data() {
    return {
      collapsed_elements: [], // List of elements marked as not showing (collapsed)
      persistentDimension: '', // Used to persist the selected dimension filter (ex: when first column link is clicked)
      primaryDimension: '', // Used for requests that only want this report's primary dimension
      reportType: '', // Used to differentiate between single- and multi-dimension report types (i.e. CarrierActivityReport and CarrierActivityReportSelected)
      dailyActivityReport: 'default text',
      isLoading: false,
      selectedProduct: null,
      agencyName: sessionStorage.getItem('userAgency'), // TODO: Use config value
      reportDataPrimary: {
        columns: [],
        rows: [],
      },
      reportDataSecondary: {
        columns: [],
        rows: [],
      },
      dataSummary: {
        columns: [],
        rows: [],
      },
      table: {
        data: {
          rows: [],
        },
      },
      table2: {
        data: {
          rows: [],
        },
      },
      filter: '',
      agencyData: null,
      chartType: {
        field_name: 'clown_field_name_2',
        field_value: 'bar',
        rules: [],
        field_type: 'text',
        help_text: 'Useful 002 help text is nice.',
        values: [
          {
            display_value: 'Bar',
            internal_value: 'bar',
          },
          {
            display_value: 'Horizontal Bar',
            internal_value: 'horizontalBar',
          },
          {
            display_value: 'Polar Area',
            internal_value: 'polarArea',
          },
          {
            display_value: 'Line',
            internal_value: 'line',
          },
        ],
        is_required: false,
        placeholder: null,
        sub_text: null,
      },
      chartEl: 'report-card-002',
      chartX: 'CarrierName',
      chartY: 'RateCallSuccess',
      chartCalc: 'sum',
      chartDateFiltersPrimary: {},
      chartDateFiltersSecondary: {},
      chartProductFilters: {},
      chartDimensionFilters: {
        field_name: 'dimensionFilters',
        field_value: '', // TODO: Use config values
        rules: [],
        field_type: 'select',
        label: 'Choose as many as you would like from this list.',
        help_text: 'You can select many choices here #4.',
        values: filters.dimensions,
        is_required: false,
        is_enabled: true,
        visible: true,
        placeholder: 'Select One',
        sub_text: null,
      },
      chartFiltersFilters: {
        states: {
          field_name: 'filtersFiltersStates',
          field_value: '', // TODO: Use config values
          rules: [],
          field_type: 'multicheckbox',
          label: 'Choose as many as you would like from this list.',
          help_text: 'You can select many choices here #4.',
          values: filters.filters.states,
          is_required: false,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        carriers: {
          field_name: 'filtersFiltersCarriersCarriers',
          field_value: '', // TODO: Use config values
          rules: [],
          field_type: 'multicheckbox',
          label: 'Choose as many as you would like from this list.',
          help_text: 'You can select many choices here #4.',
          values: filters.filters.carriers,
          is_required: false,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        teams: {
          field_name: 'filtersFiltersCarriersTeams',
          field_value: '', // TODO: Use config values
          rules: [],
          field_type: 'multicheckbox',
          label: 'Choose as many as you would like from this list.',
          help_text: 'You can select many choices here #4.',
          values: filters.filters.teams,
          is_required: false,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        agents: {
          field_name: 'filtersFiltersCarriersAgents',
          field_value: '', // TODO: Use config values
          rules: [],
          field_type: 'multicheckbox',
          label: 'Choose as many as you would like from this list.',
          help_text: 'You can select many choices here #4.',
          values: filters.filters.agents,
          is_required: false,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
        products: {
          field_name: 'filtersFiltersProducts',
          field_value: '', // TODO: Use config values
          rules: [],
          field_type: 'multicheckbox',
          label: 'Choose as many as you would like from this list.',
          help_text: 'You can select many choices here #4.',
          values: filters.products,
          is_required: false,
          is_enabled: true,
          visible: true,
          placeholder: null,
          sub_text: null,
        },
      },
      chartDateFrom: {
        field_value: '',
        field_name: 'chartDateFrom',
        field_rules: {},
        has_error: false,
      },
      chartDateTo: {
        field_value: '',
        field_name: 'chartDateTo',
        field_rules: {},
        has_error: false,
      },
      sortByField: {
        field_name: 'sortByField',
        field_value: '',
        rules: [],
        field_type: 'text',
        help_text: 'Useful 002 help text is nice.',
        values: [
          {
            display_value: 'Value Up',
            internal_value: 'value_asc',
          },
          {
            display_value: 'Value Down',
            internal_value: 'value_desc',
          },
        ],
        is_required: false,
        placeholder: null,
        sub_text: null,
      },
      insuranceType: {
        field_name: 'productFilters',
        field_value: '',
        label: 'Filter data by product:',
        rules: [],
        field_type: 'select',
        help_text: '',
        values: [],
        is_required: false,
        is_enabled: true,
        visible: true,
        sub_text: null,
      },
      reportCard: null,
      /**
       * SELECT
       * carrier, state, agent // columns
       * FROM
       * carrierReport // reportType
       * WHERE
       * carrier in [3, 100, 111] // filters
       * AND
       * state in ['CA', 'FL', 'NM'] // filters
       * AND
       * agent = ['johndoe@example.com', 'foo@example.com'] // filters
       * GROUP BY
       * carrier, state, agent // dimensions
       * ORDER BY
       * customerCount // sortBy
       * DESC // sort
       * LIMIT 0, 10 // rowStart, rowCount
       */
      dataFilters: {
        reportType: '', // i.e. 'CarrierActivity'
        dateTo: '',
        dateFrom: '',
        dateRange: (this.$router.currentRoute.query.dateRange ? this.$router.currentRoute.query.dateRange : ''), // TODO: Use config values
        dateRangeSecondary: '', // TODO: Use config values
        dimensions: [],
        filters: {
          teams: [],
          agents: [],
          carriers: [],
          states: [],
          products: [],
        },
        columns: [], // aka "select [column names]"
        sortBy: '', // aka "order by [column names]"
        sort: '', // aka "asc/desc"
        rowStart: 0, // aka "limit [start]"
        rowCount: 10, // aka "limit [end]"
        format: (this.$router.currentRoute.query.format ? this.$router.currentRoute.query.format : 'csv'), // TODO: Use config values
      },
      filters,
      queryParams: this.$router.currentRoute.query,
      dimensionProperty: '',
      numberColumns: filters.columns.currency.concat(filters.columns.numeric), // All of the columns with numbers in them
    };
  },
  components: {
    Report,
    LineChart,
    DatatableBlock,
    SummaryBlocks,
    FilterDaterange,
    FilterProducts,
    InputRadioalt,
    SortByfield,
    FilterDimension,
    FilterFilters,
  },
  computed: {
    // TODO: Refactor to use one computed property for Reports.vue and DatatableBlock.vue
    getPrimaryDimensionColumnName: {
      get() {
        let primaryDimensionColumnName = '';

        // TODO: Use config values
        switch (this.primaryDimension) {
          case 'Carrier':
            primaryDimensionColumnName = 'CarrierName';
            break;

          case 'Agent':
            primaryDimensionColumnName = 'AgentFullName';
            break;

          case 'State':
            primaryDimensionColumnName = 'StateTitleAbbrev';
            break;

          case 'Team':
            primaryDimensionColumnName = 'TeamName';
            break;

          case 'Product':
            primaryDimensionColumnName = 'ProductName';
            break;

          default:
            break;
        }

        return primaryDimensionColumnName;
      },
      set(newValue) {
        // Updates the default 'sort by', but is not used unless there is no known primary dimension
        this.sortBy = newValue;
      },
    },
    getSecondaryDimensionColumnName: {
      get() {
        let secondaryDimensionColumnName = '';

        if (this.dataFilters.dimensions.length < 1) {
          return false;
        }

        // TODO: Use config values
        switch (this.dataFilters.dimensions[1]) {
          case 'Carrier':
            secondaryDimensionColumnName = 'CarrierName';
            break;

          case 'Agent':
            secondaryDimensionColumnName = 'AgentFullName';
            break;

          case 'State':
            secondaryDimensionColumnName = 'StateTitleAbbrev';
            break;

          case 'Team':
            secondaryDimensionColumnName = 'TeamName';
            break;

          case 'Product':
            secondaryDimensionColumnName = 'ProductName';
            break;

          default:
            break;
        }

        return secondaryDimensionColumnName;
      },
      set(newValue) {
        // Updates the default 'sort by', but is not used unless there is no known primary dimension
        this.sortBy = newValue;
      },
    },
    dataLabel() {
      return (this.reportDataPrimary ? this.reportDataPrimary.label : '');
    },
    hasSecondaryDimension() {
      return (this.dataFilters.dimensions.length > 1);
    },
  },
  methods: {
    hasFilterProducts() {
      return (this.$router.currentRoute.name !== 'reports/products'); // TODO: Use config value
    },
    isMatchingRow(rowPrimary, rowSecondary) {
      let isMatchingRow = false;

      if (this.hasSecondaryDimension) {
        isMatchingRow = (rowPrimary[this.getPrimaryDimensionColumnName] === rowSecondary[this.getPrimaryDimensionColumnName] &&
          rowPrimary[this.getSecondaryDimensionColumnName] === rowSecondary[this.getSecondaryDimensionColumnName]);
      } else {
        isMatchingRow = (rowPrimary[this.getPrimaryDimensionColumnName] === rowSecondary[this.getPrimaryDimensionColumnName]);
      }

      return isMatchingRow;
    },
    /**
     * Adds rows with 0 values for columns that have numbers when comparing date ranges so all
     * rows have a matching row.
     */
    createTableUnion() {
      if (!this.chartDateFiltersSecondary.field_value) return false; // Nothing to combine if no secondary data (there's always primary data)

      // TODO: Refactor for less LOC
      this.reportDataSecondary.rows.forEach((rowSecondary) => {
        let inPrimary = false;
        this.reportDataPrimary.rows.forEach((rowPrimary) => {
          if (this.isMatchingRow(rowPrimary, rowSecondary)) {
            inPrimary = true;
          }
        });

        if (!inPrimary) {
          const blankRow = {};
          Object.assign(blankRow, rowSecondary);

          blankRow.dateRange = this.chartDateFiltersPrimary.field_value; // Use primary date range value

          this.numberColumns.forEach((numberColumn) => {
            blankRow[numberColumn] = 0; // Set all number columns to 0
          });

          this.reportDataPrimary.rows.push(blankRow); // Add new row to primary data
        }
      });

      // TODO: Refactor for less LOC
      this.reportDataPrimary.rows.forEach((rowPrimary) => {
        let inSecondary = false;
        this.reportDataSecondary.rows.forEach((rowSecondary) => {
          if (this.isMatchingRow(rowPrimary, rowSecondary)) {
            inSecondary = true;
          }
        });

        if (!inSecondary) {
          const blankRow = {};
          Object.assign(blankRow, rowPrimary);

          blankRow.dateRange = this.chartDateFiltersSecondary.field_value; // Use secondary date range value

          this.numberColumns.forEach((numberColumn) => {
            blankRow[numberColumn] = 0; // Set all number columns to 0
          });

          this.reportDataSecondary.rows.push(blankRow); // Add new row to secondary data
        }
      });

      return true;
    },
    setPersistentDimension(dimension) {
      this.persistentDimension = dimension;
    },
    resetDimensions() {
      this.chartDimensionFilters.field_value = ''; // Triggers dimensions to empty, which then triggers filters to empty
    },
    resetFilters(dimension) {
      // Unset all of the visual field values
      if (this.persistentDimension !== 'Team') {
        this.chartFiltersFilters.teams.field_value = '';
      }

      if (this.persistentDimension !== 'Agent') {
        this.chartFiltersFilters.agents.field_value = '';
      }

      if (this.persistentDimension !== 'Carrier') {
        this.chartFiltersFilters.carriers.field_value = '';
      }

      if (this.persistentDimension !== 'State') {
        this.chartFiltersFilters.states.field_value = '';
      }

      if (this.persistentDimension !== 'Product') {
        this.chartFiltersFilters.products.field_value = '';
      }

      // TODO: Refactor to use same value for dimension and `chartFiltersFilters` property name
      if (dimension) {
        switch (dimension) {
          case 'Team':
            this.chartFiltersFilters.teams.field_value = '';
            break;

          case 'Agent':
            this.chartFiltersFilters.agents.field_value = '';
            break;

          case 'Carrier':
            this.chartFiltersFilters.carriers.field_value = '';
            break;

          case 'State':
            this.chartFiltersFilters.states.field_value = '';
            break;

          case 'Product':
            this.chartFiltersFilters.products.field_value = '';
            break;

          default:
            break;
        }
      }
    },
    displayReport(routeName) {
      return (this.$router.currentRoute.name === routeName);
    },
    reportTitle(withAgencyName = false) {
      const agencyName = (withAgencyName ? this.agencyName : false);

      return Report.reportTitle(this.$router.currentRoute, agencyName);
    },
    createChart(reportDataPrimary, displayType, el) {
      const Chart = require('chart.js'); // eslint-disable-line global-require

      if (!reportDataPrimary || !displayType || !el) {
        window.console.warn('Data, displayType, or element is undefined. The chart will render with no data.');
      }

      /**
       * For debugging and reporting warnings, all y values are checked to be valid
       * numbers. It will not short-circuit since it is still valid, but the warning
       * will be logged.
       */
      if (!reportDataPrimary.metrics.every(element => typeof element === 'number' && !isNaN(element))) {
        gtag('event', 'exception', {
          description: `At least one y value is not a number in chart '${reportDataPrimary.label}'.`,
          fatal: false, // set to true if the error is fatal
        });
      }

      switch (displayType) {
        case 'bar':
        case 'horizontalBar':
        case 'polarArea':
        case 'line':
          if (this.reportCard instanceof Chart) {
            this.reportCard.destroy(); // Destroy current chart so that the canvas is empty
          }

          this.reportCard = new Chart(this.$refs[el], {
            type: displayType,
            data: {
              labels: reportDataPrimary.labels, // x-axis labels
              datasets: [{
                label: reportDataPrimary.label, // y-axis labels
                data: reportDataPrimary.metrics, // y-axis data points
                backgroundColor: [
                  'rgba(255, 99, 131, 0.2)',
                  'rgba(54, 162, 234, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 191, 0.2)',
                  'rgba(153, 102, 254, 0.2)',
                  'rgba(255, 159, 63, 0.2)',
                ],
                borderColor: [
                  'rgba(255,99,131,1)',
                  'rgba(54, 162, 234, 1)',
                  'rgba(255, 206, 85, 1)',
                  'rgba(75, 192, 191, 1)',
                  'rgba(153, 102, 254, 1)',
                  'rgba(255, 159, 63, 1)',
                ],
                borderWidth: 1,
              }],
            },
            options: {
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                }],
              },
            },
          });
          break;

        case 'line-chart':
          break;

        default:
          break;
      }
    },
    createChartFromTable(reportDataPrimary, displayType, el, xAxis, yAxis, yMath) {
      /**
       * Get running average of each x coordinate's y values. This needs to be a closure
       * since the function doesn't know how many values there will be for the denominator.
       */
      function GetAverage() {
        let value = 0; // Value to be added to the numerator
        let denominator = 0; // Value to be incremented as the denominator

        function addNumerators(valueToAdd) {
          function calcAverage() {
            return value / denominator;
          }

          if (typeof valueToAdd !== 'undefined') {
            value += valueToAdd; // Add new value to numerator
            denominator += 1; // Increment denominator
          }

          return calcAverage(); // Return current average
        }

        return addNumerators; // Return closure that will calculate the running average
      }

      const chartData = {
        labels: [],
        label: reportDataPrimary.label, // Add table title
        metrics: {},
      };

      if (reportDataPrimary.rows) {
        const rows = reportDataPrimary.rows;
        const yCalcValue = []; // Used as temporary holder of y value calculations

        for (let i = 0; i < rows.length; i += 1) {
          const xValue = rows[i][xAxis];
          const yValue = rows[i][yAxis];

          if (typeof chartData.metrics[xValue] === 'undefined') {
            chartData.metrics[xValue] = 0; // Initialize metric to 0
          }

          switch (yMath) {
            case 'sum':
              chartData.metrics[xValue] += yValue; // Add y value to its corresponding x
              break;

            case 'avg':
              if (typeof yCalcValue[xValue] !== 'function') {
                yCalcValue[xValue] = new GetAverage();
              }

              chartData.metrics[xValue] = yCalcValue[xValue](yValue); // Calculate average with new value to its corresponding x
              break;

            default:
              if (i === 0) {
                gtag('event', 'exception', {
                  description: `Unknown calc type of '${yMath}' was used to create a chart.`,
                  fatal: false, // set to true if the error is fatal
                });
              }
              break;
          }
        }

        chartData.labels = Object.keys(chartData.metrics); // Add x-axis (i.e. carriers) name to the list of labels
        chartData.metrics = Object.values(chartData.metrics); // Add y-axis values (i.e. summed up quote count) to metrics
      } else {
        chartData.labels = reportDataPrimary.labels;
        chartData.metrics = reportDataPrimary.metrics;
      }

      this.createChart(chartData, displayType, el); // Create chart!
    },
    requestUserActivity(userId = null) {
      // Return the promise so that the caller can create the chart once the data is ready
      return Report.requestUserActivity(
        userId,
      ).then((response) => {
        this.reportDataPrimary = response; // TODO: Match this up with what is actually being returned
      }).catch((error) => {
        window.console.warn('An error occurred while requesting user activity. Fallback data will be used instead.', error);
      });
    },
    requestCarrierActivity(carrierId = null) {
      // Return the promise so that the caller can create the chart once the data is ready
      return Report.requestCarrierActivity(
        carrierId,
      ).then((response) => {
        this.reportDataPrimary = response; // TODO: Match this up with what is actually being returned
      }).catch((error) => {
        window.console.warn('An error occurred while requesting carrier activity. Fallback data will be used instead.', error);
      });
    },
    requestAgencyActivity(agencyId = null) {
      // Return the promise so that the caller can create the chart once the data is ready
      return Report.requestAgencyActivity(
        agencyId,
      ).then((response) => {
        this.reportDataPrimary = response; // TODO: Match this up with what is actually being returned
      }).catch((error) => {
        window.console.warn('An error occurred while requesting agency activity. Fallback data will be used instead.', error);
      });
    },
    requestActivityTable(trigger, target) {
      // TODO: HACK: Dimension should always be correct here. Currently, both dimensions and filters cause an API request,
      // which means when the dimension is reset it does an API request, and then when the filters are reset (as a result
      // of the dimension being reset), that too does an API request. Everything works in that setup, but let's not call
      // the API before all the data is ready.
      if (
        !this.dataFilters.dimensions.length ||
        !((this.dataFilters.dateRange && target === 'primary') || (this.dataFilters.dateRangeSecondary && target === 'secondary'))
      ) { // TODO: Use config values
        return;
      }

      switch (target) {
        case 'primary':
          this.reportDataPrimary.rows = [];
          break;

        case 'secondary':
          this.reportDataSecondary.rows = [];
          break;

        default:
          break;
      }

      Report.requestActivityTable(
        this.dataFilters,
        target,
      ).then((response) => {
        // TODO: Use config values
        switch (target) {
          case 'primary':
            this.reportDataPrimary = response;
            console.log('reportDataPrimaryreportDataPrimary', this.reportDataPrimary);
            // Clear the secondary report data when the primary date range is updated
            // TODO: Reset to a default report data object
            if (!this.chartDateFiltersSecondary.field_value) {
              this.reportDataSecondary = {
                columns: [],
                rows: [],
              };
            }
            break;

          case 'secondary':
            this.reportDataSecondary = response;
            break;

          default:
            break;
        }

        const integratedTeams = Object.assign({}, this.reportDataPrimary.Teams, this.reportDataSecondary.Teams);
        const integratedAgents = Object.assign({}, this.reportDataPrimary.Agents, this.reportDataSecondary.Agents);
        const integratedCarriers = Object.assign({}, this.reportDataPrimary.Carriers, this.reportDataSecondary.Carriers);
        const integratedStates = Object.assign({}, this.reportDataPrimary.States, this.reportDataSecondary.States);
        const integratedProducts = Object.assign({}, this.reportDataPrimary.Products, this.reportDataSecondary.Products);

        this.chartFiltersFilters.teams.values = Report.populateFilters(integratedTeams);
        this.chartFiltersFilters.agents.values = Report.populateFilters(integratedAgents);
        this.chartFiltersFilters.carriers.values = Report.populateFilters(integratedCarriers);
        this.chartFiltersFilters.states.values = Report.populateFilters(integratedStates);
        this.chartFiltersFilters.products.values = Report.populateFilters(integratedProducts);

        // TODO: Avoid create table union twice; only create table union once both new data sets have returned
        this.createTableUnion(); // Combine primary and secondary data
      }).catch((error) => {
        window.console.warn('An error occurred while requesting carrier activity table. Fallback data will be used instead.', error);
      });
    },
    requestSummary() {
      const reportRequest = new ReportRequest();
      reportRequest.reportType = `${this.reportType}Top`;
      reportRequest.dateRange = this.chartDateFiltersPrimary.field_value;
      reportRequest.dimensions.push(this.primaryDimension); // Only add primary dimension
      reportRequest.productId = this.chartProductFilters.field_value;
      this.isLoading = true;
      return Report.requestSummary(
        reportRequest,
      ).then((response) => {
        this.isLoading = false;
        this.dataSummary = response;
      }).catch((error) => {
        this.isLoading = false;
        window.console.warn('An error occurred while requesting Carrier Summary.', error);
      });
    },
    /**
     * Returns whether the given ID is in the list of collapsed elements.
     */
    is_showing(elId) {
      return (this.collapsed_elements.indexOf(elId) !== -1);
    },
    /**
     * Fetches the list of collapsed elements from the session.
     */
    get_collapsed_elements_list() {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value

      return JSON.parse(sessionStorage.getItem(TOGGLE_COLLAPSE)) || []; // List of elements marked as showing
    },
    /**
     * Show/hide elements and store their state in the session.
     *
     * @param {element or string} event - The source that triggered this
     * @param {boolean} fromCollapser - Whether the collapser element triggered this (flips target and source)
     */
    toggle_collapse(event, fromCollapser = false) {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value
      const targetName = (fromCollapser ? event.id : event.currentTarget.dataset.target.substring(1)); // Name of target w/o the '#'
      const sourceName = (fromCollapser ? event.dataset.target.substring(1) : event.currentTarget.id); // ID of element that triggered this
      const i = this.collapsed_elements.indexOf(targetName); // Index of current target, if it exists in the list

      if (i === -1) {
        document.getElementById(targetName).classList.remove('show'); // Toggle whether it shows
        document.getElementById(sourceName).classList.remove('active'); // Toggle +/-
        this.collapsed_elements.push(targetName); // Add to list of showing elements
      } else {
        document.getElementById(targetName).classList.add('show'); // Toggle whether it shows
        document.getElementById(sourceName).classList.add('active'); // Toggle +/-
        this.collapsed_elements.splice(i, 1); // Remove from list of showing elements
      }

      sessionStorage.setItem(TOGGLE_COLLAPSE, JSON.stringify(this.collapsed_elements)); // Set new list back into session
    },
    /**
     * Gather route queries, set their respective filters (which will then trigger their respective 'watch').
     *
     * TODO: Needs to accept comma-delimited list instead of only one value.
     */
    gatherRouteQueries() {
      if (this.$route.query.carriers) {
        this.dataFilters.filters.carriers = [this.$route.query.carriers];
        this.setPersistentDimension('Carrier'); // TODO: Set in DatatableBlock
      }

      if (this.$route.query.agents) {
        this.dataFilters.filters.agents = [this.$route.query.agents];
        this.setPersistentDimension('Agent'); // TODO: Set in DatatableBlock
      }

      if (this.$route.query.states) {
        this.dataFilters.filters.states = [this.$route.query.states];
        this.setPersistentDimension('Carrier'); // TODO: Set in DatatableBlock
      }

      if (this.$route.query.teams) {
        this.dataFilters.filters.teams = [this.$route.query.teams];
        this.setPersistentDimension('State'); // TODO: Set in DatatableBlock
      }

      if (this.$route.query.products) {
        this.dataFilters.filters.products = [this.$route.query.products];
        this.setPersistentDimension('Product'); // TODO: Set in DatatableBlock
      }

      this.resetFilters();
    },
  },
  created() {
    // Set default value for date filter
    this.chartDateFiltersPrimary = new DateRangeFilter('dateRangeFilterPrimary', filters.dateRange);
    this.chartDateFiltersSecondary = new DateRangeFilter('dateRangeFilterSecondary', filters.dateRange);
  },
  mounted() {
    User.init().then((res) => {
      const accessibleProducts = Object.create(this.insuranceType); 
      const productOrder = [1, 21, 18, 12, QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
      const numofprodaccess = res.productAccess.length;
      if(res.productAccess.includes(QRP.PRODUCTS.AUTO) && res.productAccess.includes(QRP.PRODUCTS.HOME)) {
        res.productAccess.push(QRP.PRODUCTS.HA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.CONDO) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.CA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.RENTERS) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.RA_BUNDLE);//TODO
      }
      if (typeof res.productAccess === 'object') {
        for (let i = 0; i < productOrder.length; i += 1) {
          if (res.productAccess.includes(productOrder[i])) {
            accessibleProducts.values.push(filters.products.find(product => product.internal_value === productOrder[i]));//filters.products_with_icons[productOrder[i]]);
          }
        }
      } else {
        const productAccessArray = res.productAccess.split(',');
        for (let i = 0; i < productOrder.length; i += 1) {
          if (productAccessArray.includes(productOrder[i])) {
            accessibleProducts.values.push(filters.products[productOrder[i]]);
          }
        }
      }
      this.chartProductFilters = new ProductFilter('productFilter', accessibleProducts.values);
      
      if(numofprodaccess>=2){
        this.chartProductFilters.placeholder = 'All Products'; 
      } 
      if (this.hasFilterProducts()) {
        this.chartProductFilters.field_value = numofprodaccess >= 2 ? '' : filters.productDefault; // TODO: Use config values
      } else {
        this.chartProductFilters.field_value = ''; // TODO: Use config values
      }
    });  
 
    if (this.$route.name === 'admin/reports') {
      this.$router.push({ name: 'reports/carriers' }); // TODO: Use config values
    }

    this.collapsed_elements = this.get_collapsed_elements_list(); // TODO: Only fetch this once

    this.gatherRouteQueries();

    this.chartDateFiltersPrimary.field_value = sessionStorage.getItem(this.chartDateFiltersPrimary.field_name) || 'Today'; // TODO: Use config values
    this.chartDateFiltersSecondary.field_value = sessionStorage.getItem(this.chartDateFiltersSecondary.field_name) || ''; // TODO: Use config values
 

    switch (this.$router.currentRoute.name) {
      case 'reports/carriers':
        this.dimensionProperty = 'CarrierId'; // TODO: Use config values
        this.primaryDimension = 'Carrier';
        this.chartDimensionFilters.field_value = 'Carrier';
        this.reportType = 'CarrierActivity';
        break;

      case 'reports/teams':
        this.dimensionProperty = 'TeamId'; // TODO: Use config values
        this.primaryDimension = 'Team';
        this.chartDimensionFilters.field_value = 'Team';
        this.reportType = 'TeamActivity';
        break;

      case 'reports/agents':
        this.dimensionProperty = 'AgentId'; // TODO: Use config values
        this.primaryDimension = 'Agent';
        this.chartDimensionFilters.field_value = 'Agent';
        this.reportType = 'AgentActivity';
        break;

      case 'reports/states':
        this.dimensionProperty = 'State'; // TODO: Use config values TODO: use 'StateId' once available from the API
        this.primaryDimension = 'State';
        this.chartDimensionFilters.field_value = 'State';
        this.reportType = 'StateActivity';
        break;

      case 'reports/products':
        this.dimensionProperty = 'ProductId'; // TODO: Use config values TODO: use 'ProductId' once available from the API
        this.primaryDimension = 'Product';
        this.chartDimensionFilters.field_value = 'Product';
        this.reportType = 'ProductActivity';
        break;

      default:
        this.dimensionProperty = 'CarrierId'; // TODO: Use config values
        this.primaryDimension = 'Carrier';
        this.chartDimensionFilters.field_value = 'Carrier';
        this.reportType = 'CarrierActivity';
        break;
    }

    this.dataFilters.reportType = this.reportType;
  },
  watch: {
    // Updates chart when chart type changes (no API request needed)
    'chartType.field_value': function chartType() {
      this.createChartFromTable(this.reportDataPrimary, this.chartType.field_value, this.chartEl, this.chartX, this.chartY, this.chartCalc, this.chartDateFrom, this.chartDateTo);
    },
    // Updates chart when chartDateFrom changes (API request)
    'chartDateFrom.field_value': function chartDateFrom(newValue) {
      this.dataFilters.dateFrom = newValue;
      this.requestActivityTable('date from', 'primary');
      this.requestActivityTable('date from', 'secondary');
    },
    // Updates chart when chartDateTo changes (API request)
    'chartDateTo.field_value': function chartDateTo(newValue) {
      this.dataFilters.dateTo = newValue;
      this.requestActivityTable('date to', 'primary');
      this.requestActivityTable('date to', 'secondary');
    },
    // Updates chart when chartDateFiltersPrimary changes (API request)
    'chartDateFiltersPrimary.field_value': function chartDateFiltersPrimary(newValue) {
      this.dataFilters.dateRange = newValue;
      this.chartDateFiltersSecondary = new DateRangeFilter('dateRangeFilterSecondary', filters.dateRange, filters.secondaryDateRangePlaceholder, newValue);

      this.requestSummary();
      this.requestActivityTable('date filter', 'primary');
    },
    // Updates chart when chartDateFiltersSecondary changes (API request)
    'chartDateFiltersSecondary.field_value': function chartDateFiltersPrimary(newValue) {
      this.dataFilters.dateRangeSecondary = newValue; // DO NOT COMMIT!
      if (!newValue) {
        this.requestActivityTable('date filter', 'primary');
      } else {
        this.requestActivityTable('date filter', 'secondary');
      }
    },
    // Updates chart when chartProductFilters changes (API request)
    'chartProductFilters.field_value': function chartProductFilters(newValue) {
      this.dataFilters.productId = newValue;

      this.requestActivityTable('product filter', 'primary');
      this.requestActivityTable('product filter', 'secondary');
      this.requestSummary();
    },
    // Updates chart when chartDimensionFilters changes (API request)
    'chartDimensionFilters.field_value': function chartDimensionFilters(newValue) {
      this.dataFilters.dimensions = []; // Clear dimensions

      this.dataFilters.dimensions.push(this.primaryDimension);

      if (newValue && this.dataFilters.dimensions.indexOf(newValue) === -1) {
        this.dataFilters.dimensions.push(newValue); // Add dimension if not in list of dimensions
      }

      this.resetFilters(); // Reset filters because they don't persist

      if (this.dataFilters.dimensions.length > 1) {
        this.dataFilters.reportType = `${this.reportType}Selected`; // TODO: Remove redundant value (it's evident in the selected dimension)
      } else {
        this.dataFilters.reportType = this.reportType; // TODO: Remove redundant value (it's evident in the selected dimension)
      }

      this.requestActivityTable('dimension filters', 'primary');
      this.requestActivityTable('dimension filters', 'secondary');
    },
    // Updates chart when chartFiltersFilters changes (API request)
    'chartFiltersFilters.states.field_value': function chartFiltersFilters(newValue) {
      if (typeof newValue !== 'string') return;

      this.dataFilters.filters.states = newValue.split(',').filter(el => el !== ''); // Split on ',', remove blanks

      this.requestActivityTable('filters states', 'primary');
      this.requestActivityTable('filters states', 'secondary');
    },
    // Updates chart when chartFiltersFilters changes (API request)
    'chartFiltersFilters.agents.field_value': function chartFiltersFilters(newValue) {
      if (typeof newValue !== 'string') return;

      this.dataFilters.filters.agents = newValue.split(',').filter(el => el !== ''); // Split on ',', remove blanks

      this.requestActivityTable('filters agents', 'primary');
      this.requestActivityTable('filters agents', 'secondary');
    },
    // Updates chart when chartFiltersFilters changes (API request)
    'chartFiltersFilters.teams.field_value': function chartFiltersFilters(newValue) {
      if (typeof newValue !== 'string') return;

      this.dataFilters.filters.teams = newValue.split(',').filter(el => el !== ''); // Split on ',', remove blanks

      this.requestActivityTable('filters teams', 'primary');
      this.requestActivityTable('filters teams', 'secondary');
    },
    // Updates chart when chartFiltersFilters changes (API request)
    'chartFiltersFilters.carriers.field_value': function chartFiltersFilters(newValue) {
      if (typeof newValue !== 'string') return;

      this.dataFilters.filters.carriers = newValue.split(',').filter(el => el !== ''); // Split on ',', remove blanks

      this.requestActivityTable('filters carriers', 'primary');
      this.requestActivityTable('filters carriers', 'secondary');
    },
    // Updates chart when chartFiltersFilters changes (API request)
    'chartFiltersFilters.products.field_value': function chartFiltersFilters(newValue) {
      if (typeof newValue !== 'string') return;

      this.dataFilters.filters.products = newValue.split(',').filter(el => el !== ''); // Split on ',', remove blanks

      this.requestActivityTable('filters products', 'primary');
      this.requestActivityTable('filters products', 'secondary');
    },
    // Updates chart when sortByField changes (API request)
    'sortByField.field_value': function sortByField(newValue) {
      this.dataFilters.sortBy = newValue;
      this.dataFilters.sort = newValue;
      this.requestActivityTable('sort by', 'primary');
      this.requestActivityTable('sort by', 'secondary');
    },
  },
};
</script>
<style scoped>
.search-table-filter {
  max-width: 200px;
  display: inline-block;
}
.display-1{
  color: #3674B2;
  font-size: 1.5rem;
  font-weight: normal;
}
/**DATA TABLE CSS**/
.table-heading{
  background: #00162B;
  color: #fff;
}
  .table-heading .btn-sm{
    padding: 0.25rem 0.5rem;
  }
  .nav-item-collapse{
    cursor: pointer;
  }
  #dimension-filters-list{
    background: #EEF5FF;
    border-left: 1px solid #c8ced3;
    border-right: 1px solid #c8ced3;
  }
.card.rounded-bottom{
  border-radius: 0 0 0.25rem 0.25rem !important;
}

/* TODO: Only needed to undo the style from `SectionDisplay.vue` */
.d-inline-block {
  vertical-align: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/p_admin/Reports.vue?d5d47a4a